export default __webpack_public_path__ + "maps-guides-view-annotation-selected-960-653ae25e3a96f723d5147cee50bc4fdd.webp";